import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@/lib/i18n';        // initialise i18next (side-effect import)
import '@/styles/globals.css';

import App from './App';
import { runMagicLinkBootstrap } from '@/lib/magicLinkBootstrap';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

// Awaited before the first render so a WhatsApp magic link's session is
// fully in the auth store before any route guard evaluates -- a no-op,
// near-instant return for every normal page load without one.
runMagicLinkBootstrap().finally(() => {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
